import type { KgInsightThemeType } from '@api/api/kg-insights';

export interface SearchResult {
  id: string;
  name: string;
  type?: KgInsightThemeType;
}

export const toSelectedTheme = (item: SearchResult) => ({
  id: item.id,
  name: item.name,
  isClickable: true,
  ...(item.type ? { type: item.type } : {}),
});

export const createHandlePillClick = <T extends { isClickable: boolean }>(
  onPillClick: ((theme: T) => void) | undefined
) => {
  if (!onPillClick) {
    return undefined;
  }

  return (theme: T) => () => onPillClick({ ...theme, isClickable: true });
};
